import { render, staticRenderFns } from "./magic-topbar.vue?vue&type=template&id=3e942461&"
import script from "./magic-topbar.vue?vue&type=script&lang=js&"
export * from "./magic-topbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports